import { get } from 'lodash/object'
import auth from '~/modules/auth/auth'
import i18n from '~/plugins/nuxt-i18n/i18n'
import AppNotifications from '~/services/Notifications/AppNotifications'

export default ({ $axios, $config, store, redirect, app, route, error }) => {
  // route ініціалізується один раз при завантаженні плагіну
  $axios.setBaseURL($config.apiURL)
  const CancelToken = $axios.CancelToken
  const delegatedError = response => {
    const err = new Error()
    err.response = response
    return err
  }

  const logOut = async (isTokenDead = false) => {
    if (auth.getToken()) {
      await auth.logout(store, isTokenDead)
      AppNotifications.error(i18n.t('Auth token is outdated. Renew Please'))
      redirect('/auth')
    }
  }
  const isPublicRoute = url => {
    const publicRouteRegexp = new RegExp(
      [
        '^/api/v[12]/login$',
        '^/api/v[12]/auth/(?:get-code|get-token|logout)$',
        '^/api/v[12]/shortcodes/[^/]+$',
        '^/api/v[12]/templates/[^/]+(?:/document)?$'
      ].join('|'),
      'i'
    )
    return publicRouteRegexp.test(url)
  }

  const isGuestRoute = url => {
    const guestRouteRegexp = new RegExp(
      [
        '^/api/v[12]/documents/[^/]+(?:/(?:signatures|fields|sign|send|approve|reject|approvals|download|comments))?(?:\\?.*)?$',
        '/cloud-signature'
      ].join('|'),
      'i'
    )
    return guestRouteRegexp.test(url)
  }

  $axios.defaults.validateStatus = status => {
    return [200, 201, 202, 203, 204].includes(status)
  }
  // Authorization - основной токен
  // X-Access-Token - статичний токен для АРІ
  // X-Auth-Token - тимчасовий токен
  $axios.onRequest(request => {
    const currentRoute = app.router.currentRoute
    const source = CancelToken.source()
    const token = auth.getAuthToken()
    request.cancelToken = source.token
    const isBulkSignature = route.name === 'bulk-signature-id'
    if (!isPublicRoute(request.url)) {
      if (isBulkSignature) {
        request.headers['X-Access-Token'] = currentRoute.query?.token
        if (get(currentRoute.query, 'organization_id', null)) {
          request.headers['X-Organization'] = currentRoute.query.organization_id
        }
        request.headers['X-Client-Name'] = 'web'
        return request
      }
      const isTemplateRoute = route.name === 'templates-id'
      if (
        ((currentRoute.query.token || isTemplateRoute) && isGuestRoute(request.url)) ||
        currentRoute.name === 'widget-id'
      ) {
        const tokenMatch = currentRoute.fullPath.match(/[?&]token=([^&]+)/)
        const widgetToken = tokenMatch ? tokenMatch[1] : null
        request.headers['X-Auth-Token'] = currentRoute.query.token || widgetToken
        request.headers['X-Client-Name'] = 'web'
        request.headers['Accept-Language'] = app.i18n.locale
        return request
      }

      request.headers.Authorization = auth.getBearer()
    }

    request.headers['X-Client-Name'] = 'web'
    if (!request.headers['X-ORGANIZATION'] && !request.headers['X-Organization']) {
      request.headers['X-ORGANIZATION'] = get(
        store,
        'state.organizations.currentOrganization.id',
        null
      )
    }
    request.headers['Accept-Language'] = app.i18n.locale

    if (token) {
      request.headers.Authorization = auth.getBearer()
    }

    return request
  })

  $axios.onError(data => {
    const response = data.response
    if (response) {
      const hasTemporaryToken = get(response, 'config.headers["X-Auth-Token"]', null)
      if (response.status === 401) {
        if (hasTemporaryToken) {
          response.data.__suppressToast = true
          error(delegatedError(response))
        } else if (!hasTemporaryToken && !isPublicRoute(response.config.url)) {
          if (response.data.message === 'Invalid JWT Token') {
            logOut(true)
          } else {
            logOut(false)
            response.data.message = 'Auth token is outdated. Renew Please'
          }
        }
      }
      if (response.status === 404) {
        error(delegatedError(response))
        response.data.__suppressToast = true
      }

      if (response.status === 400) {
        response.data.__suppressToast = true
      }
      if (response.data) {
        throw delegatedError(response)
      }
    }
  })

  $axios.onResponseError(({ response }) => {
    // Executes after onError.
  })

  $axios.onResponse(response => {
    return response
  })
}
